(() => {
  const initialiseGallery = (gallery) => {
    if (gallery.dataset.wwNocturneInitialised === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const previousButton = gallery.querySelector('[data-ww-gallery-previous]');
    const nextButton = gallery.querySelector('[data-ww-gallery-next]');
    const thumbnailButtons = Array.from(
      gallery.querySelectorAll(
        '[id^="GalleryThumbnails"] [data-target] button'
      )
    );

    if (
      !viewer ||
      !previousButton ||
      !nextButton ||
      thumbnailButtons.length < 2
    ) {
      return;
    }

    gallery.dataset.wwNocturneInitialised = 'true';
        const mediaItems = gallery.querySelectorAll(
      '[id^="Slider-Gallery"] > .product__media-item'
    );
    const totalCounter = gallery.querySelector(
      '[id^="GalleryViewer"] .slider-counter--total'
    );

    const correctMobileTotal = () => {
      if (
        totalCounter &&
        totalCounter.textContent !== String(mediaItems.length)
      ) {
        totalCounter.textContent = String(mediaItems.length);
      }
    };

    correctMobileTotal();

    const initialiseNocturneMobileLoop = () => {
      if (gallery.classList.contains('ww-fabric-gallery')) return;

      const slidesTrack =
        viewer.slider ||
        gallery.querySelector('[id^="Slider-Gallery"]');
      const originalItems = Array.from(mediaItems);
      const currentCounter = gallery.querySelector(
        '[id^="GalleryViewer"] .slider-counter--current'
      );

      if (!slidesTrack || originalItems.length < 2) return;

      const isMobile = () => {
        return window.matchMedia('(max-width: 749px)').matches;
      };

      let firstClone = null;
      let lastClone = null;
      let physicalItems = originalItems;
      let logicalIndex = 0;
      let loopEnabled = false;
      let scrollFrame = null;
      let scrollTimer = null;

      const cleanClone = (clone) => {
        clone.removeAttribute('id');
        clone.removeAttribute('data-media-id');
        clone.classList.remove('is-active');
        clone.classList.add(
          'ww-nocturne-gallery__mobile-clone'
        );
        clone.setAttribute('aria-hidden', 'true');

        if ('inert' in clone) {
          clone.inert = true;
        }

        clone.querySelectorAll('[id]').forEach((element) => {
          element.removeAttribute('id');
        });

        clone
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.removeAttribute('data-media-id');
          });

        clone
          .querySelectorAll(
            'a, button, input, select, textarea, [tabindex]'
          )
          .forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });

        return clone;
      };

      const synchroniseLogicalSlide = (index) => {
        logicalIndex =
          (index + originalItems.length) %
          originalItems.length;

        originalItems.forEach((item, itemIndex) => {
          item.classList.toggle(
            'is-active',
            itemIndex === logicalIndex
          );
        });

        thumbnailButtons.forEach((button, buttonIndex) => {
          if (buttonIndex === logicalIndex) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        if (currentCounter) {
          currentCounter.textContent = String(
            logicalIndex + 1
          );
        }

        correctMobileTotal();
      };

      const nearestPhysicalIndex = () => {
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        physicalItems.forEach((item, index) => {
          const distance = Math.abs(
            item.offsetLeft - slidesTrack.scrollLeft
          );

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      viewer.wwMobileLoopUpdate = () => {
        if (!loopEnabled || !isMobile()) return false;

        const physicalIndex = nearestPhysicalIndex();
        const nextLogicalIndex =
          (physicalIndex - 1 + originalItems.length) %
          originalItems.length;
        const previousPage = viewer.currentPage;

        synchroniseLogicalSlide(nextLogicalIndex);
        viewer.currentPage = nextLogicalIndex + 1;

        if (viewer.prevButton) {
          viewer.prevButton.removeAttribute('disabled');
        }

        if (viewer.nextButton) {
          viewer.nextButton.removeAttribute('disabled');
        }

        if (viewer.currentPage !== previousPage) {
          viewer.dispatchEvent(
            new CustomEvent('slideChanged', {
              detail: {
                currentPage: viewer.currentPage,
                currentElement: originalItems[nextLogicalIndex]
              }
            })
          );
        }

        return true;
      };
      const jumpToPhysicalSlide = (physicalIndex) => {
        const targetItem = physicalItems[physicalIndex];

        if (!targetItem) return;

        slidesTrack.scrollTo({
          left: targetItem.offsetLeft,
          behavior: 'instant'
        });
      };

      let isTouching = false;

      const settleMobileLoop = () => {
        if (!loopEnabled || !isMobile() || isTouching) return;

        const physicalIndex = nearestPhysicalIndex();
        const targetItem = physicalItems[physicalIndex];

        if (!targetItem) return;

        const distanceFromAlignment = Math.abs(
          targetItem.offsetLeft - slidesTrack.scrollLeft
        );

        if (distanceFromAlignment > 2) return;

        const lastPhysicalIndex =
          physicalItems.length - 1;

        if (physicalIndex === 0) {
          synchroniseLogicalSlide(
            originalItems.length - 1
          );
          jumpToPhysicalSlide(originalItems.length);
          return;
        }

        if (physicalIndex === lastPhysicalIndex) {
          synchroniseLogicalSlide(0);
          jumpToPhysicalSlide(1);
          return;
        }

        synchroniseLogicalSlide(physicalIndex - 1);
      };

      slidesTrack.addEventListener(
        'touchstart',
        () => {
          isTouching = true;
          window.clearTimeout(scrollTimer);
        },
        { passive: true }
      );

      const finishTouch = (event) => {
        isTouching = event.touches.length > 0;

        if (isTouching) return;

        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(
          settleMobileLoop,
          100
        );
      };

      slidesTrack.addEventListener(
        'touchend',
        finishTouch,
        { passive: true }
      );

      slidesTrack.addEventListener(
        'touchcancel',
        finishTouch,
        { passive: true }
      );

      const updateMobilePosition = () => {
        if (!loopEnabled || !isMobile()) return;

        const physicalIndex = nearestPhysicalIndex();
        const lastPhysicalIndex =
          physicalItems.length - 1;

        if (physicalIndex === 0) {
          synchroniseLogicalSlide(
            originalItems.length - 1
          );
        } else if (
          physicalIndex === lastPhysicalIndex
        ) {
          synchroniseLogicalSlide(0);
        } else {
          synchroniseLogicalSlide(physicalIndex - 1);
        }

        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(
          settleMobileLoop,
          100
        );
      };

      const enableMobileLoop = () => {
        if (loopEnabled || !isMobile()) return;

        firstClone = cleanClone(
          originalItems[0].cloneNode(true)
        );
        lastClone = cleanClone(
          originalItems[
            originalItems.length - 1
          ].cloneNode(true)
        );

        [
          originalItems[0],
          originalItems[originalItems.length - 1],
          firstClone,
          lastClone
        ].forEach((item) => {
          item.querySelectorAll('img').forEach((image) => {
            image.loading = 'eager';

            if (typeof image.decode === 'function') {
              image.decode().catch(() => {});
            }
          });
        });
        slidesTrack.insertBefore(
          lastClone,
          slidesTrack.firstChild
        );
        slidesTrack.appendChild(firstClone);

        physicalItems = Array.from(
          slidesTrack.querySelectorAll(
            ':scope > .product__media-item'
          )
        );
        loopEnabled = true;

        window.requestAnimationFrame(() => {
          jumpToPhysicalSlide(logicalIndex + 1);
          synchroniseLogicalSlide(logicalIndex);
        });
      };

      const disableMobileLoop = () => {
        if (!loopEnabled) return;

        settleMobileLoop();

        if (firstClone) firstClone.remove();
        if (lastClone) lastClone.remove();

        firstClone = null;
        lastClone = null;
        physicalItems = originalItems;
        loopEnabled = false;

        thumbnailButtons[logicalIndex].click();
      };

      const updateResponsiveMode = () => {
        if (!gallery.isConnected) {
          window.removeEventListener(
            'resize',
            updateResponsiveMode
          );
          return;
        }

        if (isMobile()) {
          enableMobileLoop();
        } else {
          disableMobileLoop();
        }
      };

      slidesTrack.addEventListener(
        'scroll',
        () => {
          if (!loopEnabled || !isMobile()) return;

          if (scrollFrame) {
            window.cancelAnimationFrame(scrollFrame);
          }

          scrollFrame = window.requestAnimationFrame(
            updateMobilePosition
          );
        },
        { passive: true }
      );

      window.addEventListener(
        'resize',
        updateResponsiveMode
      );

      updateResponsiveMode();
    };

    initialiseNocturneMobileLoop();   

    if (totalCounter) {
      const totalCounterObserver = new MutationObserver(
        correctMobileTotal
      );

      totalCounterObserver.observe(totalCounter, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    const slideInterval =
      (Number(gallery.dataset.wwSlideInterval) || 6) * 1000;
    const interactionPause =
      (Number(gallery.dataset.wwInteractionPause) || 6) * 1000;

    let pauseUntil = Date.now() + slideInterval;
    let isTransitioning = false;
    let isPointerOverGallery = false;

    const registerInteraction = () => {
      pauseUntil = Date.now() + interactionPause;
    };

        const changeMedia = (direction) => {
      let currentIndex = thumbnailButtons.findIndex(
        (button) => button.getAttribute('aria-current') === 'true'
      );

      if (currentIndex < 0) currentIndex = 0;

      const nextIndex =
        (currentIndex + direction + thumbnailButtons.length) %
        thumbnailButtons.length;

      const shouldFade =
        !window.matchMedia('(max-width: 749px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!shouldFade) {
        thumbnailButtons[nextIndex].click();
        return;
      }

      if (isTransitioning) return;

      isTransitioning = true;
      viewer.slider.classList.add(
        'ww-nocturne-gallery__media-fading'
      );

      window.setTimeout(() => {
        thumbnailButtons[nextIndex].click();

        window.requestAnimationFrame(() => {
          viewer.slider.classList.remove(
            'ww-nocturne-gallery__media-fading'
          );

          window.setTimeout(() => {
            isTransitioning = false;
          }, 240);
        });
      }, 240);
    };

    previousButton.addEventListener('click', () => {
      registerInteraction();
      changeMedia(-1);
    });

    nextButton.addEventListener('click', () => {
      registerInteraction();
      changeMedia(1);
    });

    viewer.addEventListener('pointerdown', registerInteraction);
    viewer.addEventListener('keydown', registerInteraction);

    viewer.addEventListener('pointerenter', () => {
      isPointerOverGallery = true;
    });

    viewer.addEventListener('pointerleave', () => {
      isPointerOverGallery = false;
      registerInteraction();
    });

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (!reducedMotion && !gallery.classList.contains('ww-fabric-gallery')) {
      const autoplayTimer = window.setInterval(() => {
        if (!gallery.isConnected) {
          window.clearInterval(autoplayTimer);
          return;
        }

        const viewerPosition = viewer.getBoundingClientRect();

        if (
          document.hidden ||
          window.matchMedia('(max-width: 749px)').matches ||
          isPointerOverGallery ||
          isTransitioning ||
          Date.now() < pauseUntil ||
          viewerPosition.bottom <= 0 ||
          viewerPosition.top >= window.innerHeight
        ) {
          return;
        }

        changeMedia(1);
        pauseUntil = Date.now() + slideInterval;
      }, 100);
    }
  };

  const initialiseAll = () => {
    document
      .querySelectorAll('media-gallery.ww-nocturne-gallery')
      .forEach(initialiseGallery);
  };

  customElements.whenDefined('media-gallery').then(initialiseAll);

  document.addEventListener('shopify:section:load', initialiseAll);
})();